import { ReactNode } from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';
import clsx from 'clsx';

interface StatCardProps {
  title: string;
  value: string | number;
  change?: number;
  changeLabel?: string;
  icon?: ReactNode;
  iconBg?: string;
  sub?: string;
  subTone?: 'muted' | 'danger' | 'ok';
  onClick?: () => void;
}

export default function StatCard({
  title,
  value,
  change,
  changeLabel,
  icon,
  iconBg = 'bg-primary-100',
  sub,
  subTone = 'muted',
  onClick,
}: StatCardProps) {
  const isPositive = change !== undefined && change >= 0;

  return (
    <div
      className={clsx('stat-card', onClick && 'cursor-pointer hover:border-slate-300 transition-colors')}
      style={{ containerType: 'inline-size' }}
      onClick={onClick}
    >
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0 flex-1">
          <p className="stat-label">{title}</p>
          <p className="stat-value">{value}</p>
          {change !== undefined && (
            <p
              className={clsx(
                'stat-change',
                isPositive ? 'positive' : 'negative'
              )}
            >
              {isPositive ? (
                <TrendingUp className="w-4 h-4" />
              ) : (
                <TrendingDown className="w-4 h-4" />
              )}
              <span>
                {isPositive ? '+' : ''}
                {change}%
              </span>
              {changeLabel && (
                <span className="text-slate-500 ml-1">{changeLabel}</span>
              )}
            </p>
          )}
          {sub && (
            <p className={clsx(
              'text-xs font-medium mt-0.5',
              subTone === 'danger' ? 'text-danger-600' : subTone === 'ok' ? 'text-success-600' : 'text-slate-400'
            )}>{sub}</p>
          )}
        </div>
        {icon && (
          <div
            className={clsx(
              'w-9 h-9 md:w-12 md:h-12 rounded-lg flex items-center justify-center shrink-0',
              iconBg
            )}
          >
            {icon}
          </div>
        )}
      </div>
    </div>
  );
}
